var authenticityToken = $("meta[name='csrf-token']").attr("content");

function roundMoney2(n) {
  return Math.round(Number(n) * 100) / 100;
}

function callShortfallContext($form) {
  var $modal = $("#securityCodeModal");
  var $select = $form.find("select#conference_total_time_in_minutes");
  if ($select.length === 0) return null;

  var $opt = $select.find("option:selected");
  var rawPrice = $opt.data("price");
  var totalCost =
    rawPrice === undefined || rawPrice === null || rawPrice === ""
      ? 0
      : parseFloat(rawPrice);
  if (!Number.isFinite(totalCost)) totalCost = 0;

  var balance = parseFloat($modal.data("balance"));
  if (!Number.isFinite(balance)) balance = 0;

  var shortfall = roundMoney2(Math.max(0, totalCost - balance));
  var pixReady =
    $modal.data("pix-recharge") === true ||
    $modal.attr("data-pix-recharge") === "true";
  var hasCreditCard =
    $modal.data("has-credit-card") === true ||
    $modal.attr("data-has-credit-card") === "true";
  var creditCardCheckout =
    $modal.data("checkout-credit-card") === true ||
    $modal.attr("data-checkout-credit-card") === "true";

  return {
    shortfall: shortfall,
    pixReady: pixReady,
    hasCreditCard: hasCreditCard,
    creditCardCheckout: creditCardCheckout,
    balance: balance,
    totalCost: totalCost,
  };
}

function startCallPixShortfall($form, shortfall) {
  if (
    !window.pixRecharge ||
    typeof window.pixRecharge.generateWalletRechargePix !== "function"
  ) {
    window.alert(
      "Recarga via PIX indisponível. Atualize a página ou tente novamente."
    );
    return false;
  }

  window.__pixSuccessCallback = function () {
    setTimeout(function () {
      submitCallFormAjax($form);
    }, 1000);
  };

  window.pixRecharge.generateWalletRechargePix(shortfall, {
    context: "shortfall",
  });
  return true;
}

function requireCallCvvIfNeeded($form) {
  var $cvv = $form.find('input.js-call-security-code[name="securityCode"]');
  if ($cvv.length && (!$cvv.val() || String($cvv.val()).trim() === "")) {
    if (!$("#scheduleCvvModal").length) {
      window.alert("Modal de confirmação de cartão indisponível. Atualize a página e tente novamente.");
      return false;
    }
    window.__scheduleCvvPending = {
      $form: $form,
      submit: function () {
        submitCallFormAjax($form);
      },
    };
    $("#schedule-cvv-input").val("");
    $("#scheduleCvvModal").modal("show");
    return false;
  }
  return true;
}

function submitCallFormAjax($form) {
  $("body").attr("data-calling", true);

  $("#securityCodeModal .btn").addClass("disabled");

  $("#callModal").modal("show");
  $("#securityCodeModal").modal("hide");

  playAudio("#audio-calling");

  $.ajax({
    type: $form.attr("method"),
    url: $form.attr("action"),
    data: $form.serialize(),
    success: function () {},
    error: function (xhr) {
      $("#securityCodeModal .btn").removeClass("disabled");
      $("body").attr("data-calling", false);

      const j = xhr.responseJSON;
      const msg =
        j && j.message
          ? j.message
          : "Não foi possível iniciar a ligação. Tente novamente.";
      if (j?.error === "call_in_progress") {
        $("#callModal .reason-message").html("Você já está em outra chamada.");
        $("#callModal .btn-cancel").removeClass("d-block").addClass("d-none");
        $("#callModal .btn-close").removeClass("d-none").addClass("d-block");
      } else if (j?.error === "callee_in_call") {
        $("#callModal .reason-message").html(
          "Este profissional está em atendimento no momento."
        );
        $("#callModal .btn-cancel").removeClass("d-block").addClass("d-none");
        $("#callModal .btn-close").removeClass("d-none").addClass("d-block");
      } else if (j?.error === "invalid_duration") {
        $("#callModal .reason-message").html(msg);
        $("#callModal .btn-cancel").removeClass("d-block").addClass("d-none");
        $("#callModal .btn-close").removeClass("d-none").addClass("d-block");
      } else {
        $("#callModal .reason-message").html(msg);
        $("#callModal .btn-cancel").removeClass("d-block").addClass("d-none");
        $("#callModal .btn-close").removeClass("d-none").addClass("d-block");
      }
      $("#callModal").modal("show");
    },
  });
}

$("#btn-call").click(function () {
  var professionalUserSlug = $(this).attr("data-user-slug");

  $("body").attr("data-calling", true);

  $.ajax({
    type: "post",
    url: "/calls",
    data: {
      professional_user_slug: professionalUserSlug,
      authenticity_token: authenticityToken,
    },
    success: function () {},
    error: function (data) {
      if (data.responseJSON.error === "call_in_progress") {
        $("#callModal").modal("show");
        $("#callModal .reason-message").html("Você já está em outra chamada.");
        $("#callModal .btn-cancel").removeClass("d-block").addClass("d-none");
        $("#callModal .btn-close").removeClass("d-none").addClass("d-block");
      } else if (data.responseJSON.error === "callee_in_call") {
        $("#callModal").modal("show");
        $("#callModal .reason-message").html(
          "Este profissional está em atendimento no momento."
        );
        $("#callModal .btn-cancel").removeClass("d-block").addClass("d-none");
        $("#callModal .btn-close").removeClass("d-none").addClass("d-block");
      }
    },
  });
});

$(".btn-call-accept").click(function () {
  if (window.__incomingCallAccepting || window.__incomingCallAccepted) return;

  window.__incomingCallAccepting = true;
  $("#incomingCall").addClass("call-accepted");
  $("body").attr("data-calling", true);

  var userSlug = $(this).data("user-slug");

  $.ajax({
    type: "post",
    url: "/calls/accepts",
    data: {
      user_slug: userSlug,
      authenticity_token: authenticityToken,
    },
    success: function (data) {
      window.__incomingCallAccepted = true;
      window.__incomingCallAccepting = false;
      $("#incomingCall").modal("hide");
      if (data && data.conference_uuid) {
        window.location.href = "/conferences/" + data.conference_uuid;
      }
    },
    error: function (xhr) {
      window.__incomingCallAccepting = false;
      const j = xhr.responseJSON;
      if (j && j.message) {
        window.alert(j.message);
      }
    },
  });
});

$(".btn-free-call").on("click", async function (event) {
  var $form = $(event.target).parents("form");
  var isValid = $form[0].checkValidity();

  if (isValid) {
    event.preventDefault();
    event.stopPropagation();

    $("body").attr("data-calling", true);

    $("#securityCodeModal .btn").addClass("disabled");

    $("#callModal").modal("show");
    $("#securityCodeModal").modal("hide");

    playAudio("#audio-calling");

    $.ajax({
      type: $form.attr("method"),
      url: $form.attr("action"),
      data: $form.serialize(),
      success: function () {},
      error: function (xhr) {
        $("#securityCodeModal .btn").removeClass("disabled");
        $("body").attr("data-calling", false);

        const j = xhr.responseJSON;
        const msg =
          j && j.message
            ? j.message
            : "Não foi possível iniciar a ligação. Tente novamente.";
        if (j?.error === "call_in_progress") {
          $("#callModal .reason-message").html("Você já está em outra chamada.");
          $("#callModal .btn-cancel").removeClass("d-block").addClass("d-none");
          $("#callModal .btn-close").removeClass("d-none").addClass("d-block");
        } else if (j?.error === "callee_in_call") {
          $("#callModal .reason-message").html(
            "Este profissional está em atendimento no momento."
          );
          $("#callModal .btn-cancel").removeClass("d-block").addClass("d-none");
          $("#callModal .btn-close").removeClass("d-none").addClass("d-block");
        } else if (j?.error === "invalid_duration") {
          $("#callModal .reason-message").html(msg);
          $("#callModal .btn-cancel").removeClass("d-block").addClass("d-none");
          $("#callModal .btn-close").removeClass("d-none").addClass("d-block");
        } else {
          $("#callModal .reason-message").html(msg);
          $("#callModal .btn-cancel").removeClass("d-block").addClass("d-none");
          $("#callModal .btn-close").removeClass("d-none").addClass("d-block");
        }
        $("#callModal").modal("show");
      },
    });
  }
});

$(".btn-security-code").on("click", async function (event) {
  var $form = $(event.target).parents("form");
  event.preventDefault();
  event.stopPropagation();

  var hasModernCheckout =
    $form.find('input.js-call-security-code[name="securityCode"]').length > 0;
  if (!hasModernCheckout && !$form[0].checkValidity()) {
    $form[0].reportValidity();
    return;
  }

  var $select = $form.find("select#conference_total_time_in_minutes");
  if ($select.length === 0) {
    submitCallFormAjax($form);
    return;
  }

  if (!$select.val()) {
    $form[0].reportValidity();
    return;
  }

  var ctx = callShortfallContext($form);
  if (!ctx) {
    submitCallFormAjax($form);
    return;
  }

  if (ctx.shortfall >= 0.01) {
    var canUsePix = ctx.pixReady;
    var canUseCreditCard = ctx.creditCardCheckout && ctx.hasCreditCard;

    if (canUsePix && ctx.creditCardCheckout) {
      if (!$("#schedulePaymentRequiredModal").length) {
        startCallPixShortfall($form, ctx.shortfall);
        return;
      }
      window.__schedulePaymentMethodPending = {
        $form: $form,
        shortfall: ctx.shortfall,
        hasCreditCard: ctx.hasCreditCard,
        canUsePix: canUsePix,
        balance: ctx.balance,
        openCvv: function () {
          return requireCallCvvIfNeeded($form);
        },
      };
      $("#schedulePaymentRequiredModal").modal("show");
      return;
    }

    if (canUsePix) {
      startCallPixShortfall($form, ctx.shortfall);
      return;
    }

    if (canUseCreditCard && !requireCallCvvIfNeeded($form)) return;
  }

  submitCallFormAjax($form);
});
